'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'marker';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5a1';
var svgPathData = 'M347.1 41.5L184 204.7 307.3 328 470.5 164.9c16.4-16.4 25.5-38.5 25.5-61.7 0-48.2-39-87.2-87.2-87.2-23.1 0-45.3 9.2-61.7 25.5zM172.7 216l-59 59C66.1 322.6 34.3 383.7 22.6 450l-6.5 36.7c-.5 2.6 .4 5.2 2.2 7s4.5 2.7 7 2.2l36.7-6.5c66.3-11.7 127.3-43.5 174.9-91.1l59-59-123.3-123.3zM335.8 30.2c19.4-19.4 45.6-30.2 73-30.2 57 0 103.2 46.2 103.2 103.2 0 27.4-10.9 53.6-30.2 73L248.3 409.7c-49.9 49.9-114 83.3-183.5 95.5l-36.7 6.5C20.5 513 12.6 510.5 7 505s-8-13.4-6.7-21.1l6.5-36.7c12.3-69.5 45.6-133.6 95.5-183.5l203-203-21.1-21.1c-15.6-15.6-40.9-15.6-56.6 0L109.7 157.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L216.4 28.3c21.9-21.9 57.3-21.9 79.2 0l21.1 21.1 19.1-19.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMarker = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;